/**
 * @file Selfie Capture countdown component.
 */

import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class SelfieCaptureCountdown extends Component {
  static propTypes = {
    from: PropTypes.number.isRequired,
    step: PropTypes.number,
    onFinished: PropTypes.func,
    displayOnFinish: PropTypes.bool,
    render: PropTypes.func,
  };

  static defaultProps = {
    displayOnFinish: true,
    step: 1000,
  };

  state = {
    remaining: '',
  };

  interval = null;

  startDate = null;

  componentDidMount() {
    const { from, step } = this.props;
    this.startDate = Date.now() + step * from;

    this.countdown(); // sets initial number
    this.interval = setInterval(this.countdown, step);
  }

  componentDidUpdate(prevProps) {
    const { from, step } = this.props;

    if (prevProps.from !== from) {
      this.startDate = Date.now() + step * from;

      clearInterval(this.interval);
      this.countdown(); // sets initial number
      this.interval = setInterval(this.countdown, step);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  countdown = () => {
    const { onFinished, displayOnFinish, step } = this.props;
    const momentDate = moment(this.startDate);
    const now = moment();

    const remaining = momentDate.diff(now, 'seconds', true);

    if (Math.ceil(remaining) <= 0) {
      clearInterval(this.interval);
      this.setState(
        () => ({
          remaining: displayOnFinish ? '0' : '',
        }),
        () => {
          if (onFinished) {
            onFinished();
          }
        },
      );
      return;
    }

    this.setState(() => ({
      remaining: Math.ceil(remaining * (1000 / step)),
    }));
  };

  render() {
    const { remaining } = this.state;
    const { render } = this.props;

    if (render) {
      return render(remaining);
    }

    return remaining;
  }
}

export default SelfieCaptureCountdown;
